<template>
  <v-dialog v-model="imageUploaderSelecter" persistent scrollable width="800">
    <v-card>
      <v-tabs v-model="tab" fixed-tabs background-color="indigo" dark>
        <v-tab>
          <v-btn text @click="pictureGallaryOn"> メディアギャラリー </v-btn>
        </v-tab>
        <v-tab> ファイルアップロード </v-tab>

        <v-tab v-if="useImageUrl"> 画像URL </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="scroll">
        <v-tab-item>
          <v-card-text style="height: 500px">
            <picture-gallary
              :picture-gallary="pictureGallary"
              @close-selecter-tab="closeSelecterTab"
              @select-picture="updateImage"
            />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-row class="px-8" style="height: 500px" align-content="center">
            <image-direct-uploader
              @upload-download-image="uploadDownloadImage"
              @upload-picture="uploadPicture"
            >
            </image-direct-uploader>
          </v-row>
        </v-tab-item>

        <v-tab-item v-if="useImageUrl">
          <v-row class="px-8" style="height: 500px" align-content="center">
            <v-text-field
              ref="imageUrlLinkForm"
              v-model="imageUrl"
              type="url"
              :rules="[urlValidation]"
              label="画像URL"

            />
            <v-btn @click="closeImageUrlTab"> 設定する </v-btn>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
      <v-card>
        <v-btn color="blue darken-1" text @click="$emit('close-image-uploader-selecter')">
          Close
        </v-btn>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import PictureGallary from './PictureGallary'
import ImageDirectUploader from './ImageDirectUploader'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'ImageUploaderSelecter',
  components: {
    PictureGallary,
    ImageDirectUploader
  },
  mixins: [formValidationUtils],
  props: {
    imageUploaderSelecter: {
      type: Boolean,
      required: true
    },
    imageDirectUrl: {
      type: String,
      required: false,
      default: ''
    },
    useImageUrl: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      tab: null,
      pictureGallary: false,
      imageUrl: null
    }
  },
  methods: {
    validateForm () {
      this.valid = this.$refs.imageUrlLinkForm.validate()
    },
    closeSelecterTab () {
      this.$emit('close-image-uploader-selecter')
    },
    closeImageUrlTab () {
      this.validateForm()
      if (!this.valid) {
        return false
      }
      this.updateImageDirectUrl()
      this.$emit('close-image-uploader-selecter')
    },
    updateImage (picture) {
      this.$emit('select-picture', picture)
    },
    uploadDownloadImage (downloadImage) {
      this.$emit('upload-download-image', downloadImage)
    },
    updateImageDirectUrl () {
      this.$emit('update:imageDirectUrl', this.imageUrl)
    },
    uploadPicture (picture) {
      this.$emit('upload-picture', picture)
    },
    pictureGallaryOn () {
      this.PictureGallary = true
    }
  }
}
</script>
<style scoped>
.scroll {
  overflow-y: auto;
}
</style>
